import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ExternalLink from '../external-link'

const PotentialLink: React.FC<PotentialLinkProps> = ({
  children,
  link,
  external,
  className,
  onClick,
  ...props
}): JSX.Element => {
  if (link) {
    const commonProps = { ...props, className, onClick }

    if (external) {
      return (
        <ExternalLink {...commonProps} url={link}>
          {children}
        </ExternalLink>
      )
    }

    return (
      <Link {...commonProps} to={link}>
        {children}
      </Link>
    )
  }

  return <Fragment>{children}</Fragment>
}

interface PotentialLinkProps {
  children: React.ReactNode
  link?: string
  external?: boolean
  className?: string
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

PotentialLink.propTypes = {
  children: PropTypes.node.isRequired,
  link: PropTypes.string,
  external: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export default PotentialLink
